import { detectLocale } from "../../utils/localeUtil";
import { getErrorStatus } from "../utils/getErrorStatus";

export type SearchSuggestionsResult =
  | { success: true; searchSuggestions: string[] }
  | { success: false; status: number | undefined };

export const getSearchSuggestions = async (
  apiUrl: string,
  token: string,
  query: string,
  signal?: AbortSignal,
): Promise<SearchSuggestionsResult> => {
  const url = new URL(`${apiUrl}/search_suggestions`);
  url.searchParams.set("q", query);
  url.searchParams.set("lang", detectLocale() ?? "");

  try {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      signal,
    });

    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`, {
        cause: response.status,
      });
    }

    const searchSuggestions = (await response.json()) as string[];
    return {
      success: true,
      searchSuggestions: searchSuggestions.filter(s => s.length <= 140),
    };
  } catch (error) {
    return { success: false, status: getErrorStatus(error) };
  }
};
